import { useMemo, useState } from "react";
import { Position } from "@xyflow/react";
import { HandleProps } from "@/components/nodes/types";

export default function useHandles() {
  const [variables, setVariables] = useState<Record<string, string[]>>({});
  const onVariablesChange = (id: string, variables: string[]) => {
    setVariables((prev) => ({
      ...prev,
      [id]: variables,
    }));
  };

  const handles: HandleProps[] = useMemo(() => {
    return [...new Set(Object.values(variables).flat())].map((variable) => ({
      type: "target",
      position: Position.Left,
      id: variable,
      label: variable,
    }));
  }, [variables]);

  return { onVariablesChange, handles };
}
